import { render, staticRenderFns } from "./blog-category.vue?vue&type=template&id=e56ed2a4&"
import script from "./blog-category.vue?vue&type=script&lang=js&"
export * from "./blog-category.vue?vue&type=script&lang=js&"
import style0 from "./blog-category.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports